import React from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";

const pulsePoints = [
  { left: "58%", top: "31%", delay: 0 },
  { left: "45%", top: "49%", delay: 1.2 },
  { left: "66%", top: "57%", delay: 2.1 },
  { left: "39%", top: "67%", delay: 3 },
];

const FloatingBackground = ({ mapY, glowY }) => {
  return (
    <Box
      aria-hidden="true"
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
          maskImage:
            "radial-gradient(circle at 50% 44%, rgba(0,0,0,0.86), transparent 72%)",
          opacity: 0.42,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          opacity: 0.1,
          backgroundImage:
            "radial-gradient(circle at 20% 30%, rgba(255,255,255,0.9) 0 1px, transparent 1px), radial-gradient(circle at 70% 60%, rgba(255,255,255,0.7) 0 1px, transparent 1px)",
          backgroundSize: "22px 22px, 31px 31px",
          mixBlendMode: "screen",
        }}
      />

      <Box
        component={motion.div}
        style={{ y: glowY }}
        sx={{
          position: "absolute",
          width: { xs: 260, md: 520 },
          height: { xs: 260, md: 520 },
          top: { xs: 70, md: 86 },
          left: { xs: "-24%", md: "9%" },
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0,213,200,0.2), rgba(0,213,200,0.05) 42%, transparent 70%)",
          filter: "blur(20px)",
        }}
      />

      <Box
        component={motion.div}
        style={{ y: glowY }}
        sx={{
          position: "absolute",
          width: { xs: 300, md: 640 },
          height: { xs: 300, md: 640 },
          right: { xs: "-32%", md: "3%" },
          bottom: { xs: "23%", md: "10%" },
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(18,168,157,0.18), rgba(212,176,106,0.08) 38%, transparent 72%)",
          filter: "blur(24px)",
        }}
      />

      <Box
        component={motion.svg}
        style={{ y: mapY }}
        viewBox="0 0 420 500"
        sx={{
          position: "absolute",
          width: { xs: 310, sm: 390, md: 520 },
          height: "auto",
          left: "50%",
          top: { xs: 260, md: 230 },
          transform: "translateX(-50%)",
          opacity: { xs: 0.08, md: 0.105 },
        }}
      >
        <defs>
          <linearGradient id="sa-map-line" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#00D5C8" />
            <stop offset="100%" stopColor="#D4B06A" />
          </linearGradient>
        </defs>
        <path
          d="M96 84 C130 62 178 47 224 61 C255 71 276 95 303 111 C337 132 371 142 382 176 C395 217 359 254 354 292 C349 329 366 363 343 393 C315 430 259 429 222 448 C184 468 147 457 124 425 C102 394 111 352 87 329 C62 304 26 297 28 258 C30 221 65 202 74 170 C83 139 68 104 96 84 Z"
          fill="rgba(0,213,200,0.08)"
          stroke="url(#sa-map-line)"
          strokeWidth="2"
        />
        <path
          d="M129 154 C176 125 235 130 290 166 M104 231 C167 205 241 210 324 248 M124 319 C182 292 253 298 319 334"
          fill="none"
          stroke="#00D5C8"
          strokeWidth="1.5"
          strokeLinecap="round"
          opacity="0.7"
        />
      </Box>

      {pulsePoints.map((point) => (
        <Box
          key={`${point.left}-${point.top}`}
          component={motion.div}
          sx={{
            position: "absolute",
            left: point.left,
            top: point.top,
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: "#00D5C8",
            boxShadow: "0 0 24px rgba(0,213,200,0.8)",
          }}
          animate={{
            opacity: [0.16, 0.58, 0.16],
            scale: [0.8, 1.28, 0.8],
          }}
          transition={{
            duration: 4.8,
            delay: point.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
    </Box>
  );
};

export default FloatingBackground;
